import { setUpModals } from '~/components/shared/controllers/modalController';
import { useHttpForBookingTimes } from '~/components/b2c/marketplace_landing_page/landingPageBookableTimes';

const moreProvidersLink = document.querySelector('[data-more-providers-link]');

const loadMoreProviders = () => {
  updateButtonToPending();

  const redirect = redirectToDiretoryIfNeeded();
  if (redirect) {
    return;
  }

  const url = createMoreProvidersUrl();
  fetch(url)
    .then((response) => response.text())
    .then((data) => {
      handleNewProvidersData(data);
    });
};

const updateButtonToPending = () => {
  const innerText = moreProvidersLink.innerText;
  moreProvidersLink.dataset.innerText = innerText;
  moreProvidersLink.innerText = '';
  moreProvidersLink.classList.add('loading');
};

const redirectToDiretoryIfNeeded = () => {
  const directoryLinkEl = document.querySelector(
    '[data-marketplace-landing-page-directory-link]',
  );
  if (!directoryLinkEl) {
    return false;
  }

  const directoryLink =
    directoryLinkEl.dataset.marketplaceLandingPageDirectoryLink;
  const currentProviderPage = moreProvidersLink.getAttribute(
    'data-current-provider-page',
  );
  if (directoryLink && currentProviderPage == '2') {
    window.location.href = directoryLink;
    return true;
  }
};

const createMoreProvidersUrl = () => {
  const currentProviderPage = moreProvidersLink.getAttribute(
    'data-current-provider-page',
  );
  const nextPage = parseInt(currentProviderPage) + 1;
  const currentHref = window.location.href;
  const url = new URL(currentHref);
  url.searchParams.set('page', nextPage);
  url.searchParams.set('additional_listings', 'true');
  moreProvidersLink.setAttribute('data-current-provider-page', nextPage);
  return url;
};

const handleNewProvidersData = (data) => {
  const parser = new DOMParser();
  const html = parser.parseFromString(data, 'text/html');
  const allCards = document.querySelectorAll('.cards');
  const cards = allCards[allCards.length - 1];
  const newCards = html.querySelector('.cards');

  if (!newCards) {
    removeMoreProvidersLink(cards);
  } else {
    addNewModals(html);
    addNewCards(cards, newCards);
    updatePageScroll(cards, newCards);
    updateButtonToComplete();
    setUpModals();

    const newCardLocationData = Array.from(newCards.children)
      .map((card) => {
        if (!(card.dataset.bookingTimesCard == 'true')) {
          return null;
        }

        return {
          id: card.dataset.segmentLocationId,
          number_of_booking_times:
            parseInt(card.dataset.numberOfBookingTimes) || 4,
          prevent_waitlist: card.dataset.preventWaitlist == 'true',
        };
      })
      .filter(Boolean);

    useHttpForBookingTimes(newCardLocationData);
    setTimeout(() => {
      newCards.classList.remove('new-cards');
    }, 10);
  }
};

const removeMoreProvidersLink = (cards) => {
  moreProvidersLink.remove();
  const noMoreProviders = document.createElement('h4');
  noMoreProviders.innerText =
    "We're still growing. We're working to add providers that meet your filter criteria. Be sure to check back soon!";
  noMoreProviders.style = 'text-align: center;';
  cards.insertAdjacentElement('afterend', noMoreProviders);
};

const addNewModals = (html) => {
  const newModals = html.querySelector('.marketplace_landing_page__modals');
  const newModalsContent = newModals.innerHTML;
  const currentModals = document.querySelector('[data-modal-container]');
  currentModals.insertAdjacentHTML('beforeend', newModalsContent);
};

const addNewCards = (cards, newCards) => {
  newCards.classList.add('new-cards');
  cards.insertAdjacentElement('afterend', newCards);
};

const updatePageScroll = (cards) => {
  // this method improves the user experience.  It is not perfect but it is better than it is without it.

  if (window.innerWidth < 1290) {
    return;
  }

  const scrollY = window.scrollY;
  const cardsTop = cards.getBoundingClientRect().top;
  const scrollPoint = scrollY + cardsTop + 100;
  if (scrollPoint < scrollY) {
    window.scrollTo(0, scrollPoint);
  }
};

const updateButtonToComplete = () => {
  const updatedMoreProvidersLink = document.querySelector(
    '[data-more-providers-link]',
  );
  const innerText = updatedMoreProvidersLink.dataset.innerText;
  updatedMoreProvidersLink.classList.remove('loading');
  updatedMoreProvidersLink.innerText = innerText;
};

if (moreProvidersLink) {
  moreProvidersLink.addEventListener('click', function () {
    loadMoreProviders();
  });
}
